'use client';
import AdminSetupContent from './components/AdminSetupContent';

export default function AdminSetupPage() {
  return <AdminSetupContent />;
}
